import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import { togglePhonePrompt } from 'redux-modules/auth/actions';
import AuthWrapper from 'components/AuthWrapper';

const PhonePromptSuccess = ({ togglePhonePromptConnect }) => {
  const handleClick = () => {
    if (localStorage.getItem('isMobilePrompt') === '1') {
      localStorage.setItem('isMobilePrompt', '0');
      let url = localStorage.getItem('oAuthRedirectUrl');
      window.location.assign(url);
    } else {
      togglePhonePromptConnect(false);
    }
  };

  return (
    <AuthWrapper>
      <h2 className="AuthWrapper__content-headline">Login updated!</h2>
      <p>You can use your mobile number to login as your hStream ID.</p>
      <Button color="primary" block onClick={handleClick}>
        Continue
      </Button>
    </AuthWrapper>
  );
};

PhonePromptSuccess.propTypes = {
  togglePhonePromptConnect: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  togglePhonePromptConnect: togglePhonePrompt,
};

export default connect(null, mapDispatchToProps)(PhonePromptSuccess);
